import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  debug: false,
  fallbackLng: false,
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
  lng: 'cimode',
  resources: {
    en: {},
    es: {},
  },
  keySeparator: '&!',
  nsSeparator: '|^',
});

export default i18n;
